import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Heading } from 'src/components/Heading';
import { Can, Subject } from 'src/hooks/usePermissions';
import { AutomationsTab } from '../components/AutomationsTab';
import { CreateCampaignDialog } from './components/CreateCampaignDialog';
import { StabilityLevel } from 'src/types/stability-level';

export const Automations = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const campaignName = searchParams.get('campaignName');
  const campaignDescription = searchParams.get('campaignDescription');

  const hasCampaignDetails = useMemo(() => {
    return (
      (campaignName?.length ?? 0) > 0 && (campaignDescription?.length ?? 0) > 0
    );
  }, [campaignName, campaignDescription]);

  useEffect(() => {
    if (hasCampaignDetails) {
      setIsCreateOpen(true);
    }
  }, [hasCampaignDetails]);

  const handleCloseCreateCampaignDialog = () => {
    setIsCreateOpen(false);
    searchParams.delete('campaignName');
    searchParams.delete('campaignDescription');
    setSearchParams(searchParams);
  };

  return (
    <>
      <Heading
        title="Campaigns"
        subtitle="Set up campaigns to automate outbound calls."
        stabilityLevel={StabilityLevel.Beta}
      />

      <CreateCampaignDialog
        isOpen={isCreateOpen}
        onClose={handleCloseCreateCampaignDialog}
        onNext={() => setIsCreateOpen(false)}
      />

      <Can operation="read" subject={Subject.CAMPAIGNS}>
        {/* Render only when index is known (always true after first render) */}
        <AutomationsTab beta onNewCampaign={() => setIsCreateOpen(true)} />
      </Can>
    </>
  );
};
